import { useState } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

import EmptyMessagePlaceHolder from 'molecules/EmptyMessagePlaceHolder/emptyMessagePlaceHolder';
import { getOrderItemJSX } from './orderHistoryOrderItemTemplates';
import NeedHelp from 'organisms/NeedHelp/Container/NeedHelp';
export const getOrderHistoryHeaderJSX = params => {
  const { orderHistoryDetails } = params;
  const { isMobileView, props } = orderHistoryDetails;
  return (
    <>
      <div className='order-history-header col-12'>
        {isMobileView && (
          <img
            alt='back-arrow'
            src={IMAGE_PATH?.Arrow}
            className='back-icon'
            data-testid='order-history-back-btn'
            onClick={() => props?.updateMenu('')}
          />
        )}
        <span className='order-history-heading'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HISTORY_TAG)}</span>
      </div>
      {isMobileView && (
        <div className='order-history-title'>
          <h3 className='order-history-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HISTORY_TAG)}</h3>
        </div>
      )}
    </>
  );
};

export const getEmptyMessagePlaceHolderJSX = params => {
  const { orderHistoryDetails } = params;
  const { orderHistory, orderHistoryLoading } = orderHistoryDetails;

  return (
    orderHistory?.length === 0 &&
    !orderHistoryLoading && <EmptyMessagePlaceHolder placeHolderText={TRANSLATE_MAPPING_KEY?.NO_ORDER_HISTORY_MSG} />
  );
};

export const getLoadMorePanelJSX = params => {
  const { orderHistoryDetails, updateSetOrderHistoryDetails } = params;
  const { completedOrderHistory, displayAllRecords, displayNumOfRecords, currentPage, totalNumOfPages } =
    orderHistoryDetails;
  return (
    completedOrderHistory?.length > 0 &&
    displayNumOfRecords < completedOrderHistory?.length &&
    !displayAllRecords && (
      <div className='order-History-Footer col-12'>
        <div className='load-more'>
          <ButtonComp
            className='button transparent-btn footer-btn'
            data-testid='load-more-btn'
            aria-label={translateWithI18Next(TRANSLATE_MAPPING_KEY?.LOAD_MORE)}
            onClickHandler={() =>
              updateSetOrderHistoryDetails({
                currentPage: currentPage + 1,
                displayAllRecords: currentPage + 1 >= totalNumOfPages,
              })
            }
          >
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.LOAD_MORE)}</span>
          </ButtonComp>
        </div>
        <div className='view-order-count'>
          <span>{`${translateWithI18Next(TRANSLATE_MAPPING_KEY?.VIEWED)} ${
            displayNumOfRecords * currentPage
          } ${translateWithI18Next(TRANSLATE_MAPPING_KEY?.OF)} ${completedOrderHistory?.length}`}</span>
        </div>
      </div>
    )
  );
};

export const GetHaveQuestionSectionJSX = params => {
  const { orderHistoryDetails } = params;
  const { isMobileView, showHaveQuestionSection } = orderHistoryDetails;
  const [openModal, setToggle] = useState(false);

  return (
    !isMobileView &&
    showHaveQuestionSection && (
      <div className='order-history-header col-12'>
        <div className='order-History-Footer col-12'>
          <hr className='horizontal-bar' />
          <div className='get-help-section'>
            <div className='footer-bootm-left'>
              <span className='have-a-question'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.HAVE_A_QUESTION)}</span>
              <span className='connect-specialist'>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CONNECT_WITH_SPECIALIST)}
              </span>
            </div>
            <ButtonComp
              className='button transparent-btn footer-btn '
              data-testid='getHelp-btn'
              aria-label={translateWithI18Next(TRANSLATE_MAPPING_KEY?.GET_HELP)}
              onClickHandler={() => setToggle(true)}
            >
              <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.GET_HELP)}</span>
            </ButtonComp>
          </div>
        </div>
        {openModal && <NeedHelp orderHistoryPage={true} isOpen={openModal} handleClose={() => setToggle(false)} />}
      </div>
    )
  );
};
export const getCurrentOrdersPanelJSX = params => {
  const { orderHistoryDetails } = params;
  const { currentOrderHistory } = orderHistoryDetails;

  return (
    currentOrderHistory?.length > 0 && (
      <div className='order-History-current-order-section col-12'>
        <span className='order-section-header col-12'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CURRENT_ORDERS)} ({currentOrderHistory?.length})
        </span>
        {currentOrderHistory?.map(orderDetails => getOrderItemJSX({ ...params, orderDetails }))}
      </div>
    )
  );
};
export const getCompletedOrdersPanelJSX = params => {
  const { orderHistoryDetails } = params;
  const { completedOrderHistory, displayAllRecords, displayNumOfRecords, currentPage } = orderHistoryDetails;

  return (
    completedOrderHistory?.length > 0 && (
      <div className='order-History-completed-order-section col-12'>
        <span className='order-section-header col-12'>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.COMPLETED_ORDERS_TEXT)} ({completedOrderHistory?.length})
        </span>
        {completedOrderHistory?.map(
          (orderDetails, index) =>
            (index < displayNumOfRecords * currentPage || displayAllRecords) &&
            getOrderItemJSX({ ...params, orderDetails }),
        )}
      </div>
    )
  );
};
